import type { HttpPost, HttpRequest } from '@/shared/infra/http'
import { mapServerError } from '@/shared/infra/http'
import type { ProPlanChangePreview } from '@/shared/domain'
import type { PreviewProPlanChange } from '@/modules/auth/use-cases'

export class EdgePreviewProPlanChangeRepository {
  constructor(private readonly httpClient: HttpPost) {}

  execute: PreviewProPlanChange = async (params) => {
    const body = { targetPlan: params.targetPlan }
    const request: HttpRequest<typeof body> = {
      url: '/pro-billing/plan-change/preview',
      body,
    }
    try {
      return await this.httpClient.post<typeof body, ProPlanChangePreview>(request)
    } catch (err) {
      mapServerError(err)
    }
  }
}
